import { render, staticRenderFns } from "./MadeByFoot.vue?vue&type=template&id=cd11db10&"
import script from "./MadeByFoot.vue?vue&type=script&lang=js&"
export * from "./MadeByFoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports